import { render, staticRenderFns } from "./saveQuestion.vue?vue&type=template&id=0be2832a&"
import script from "./saveQuestion.vue?vue&type=script&lang=js&"
export * from "./saveQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports